/* Maison Noir theme, storefront behaviour */
(function () {
  'use strict';
  var S = window.themeSettings || {};
  var R = S.routes || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* Money */
  function formatMoney(cents) {
    var fmt = S.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    function withDelims(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* Drawers */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('[data-close-drawer]'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.modal.is-open')) document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); $$('.modal.is-open').forEach(closeModal); }
  });

  /* Search toggle */
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var bar = $('#HeaderSearch'); if (!bar) return;
      bar.classList.toggle('is-open');
      if (bar.classList.contains('is-open')) { var i = bar.querySelector('input'); if (i) i.focus(); }
    });
  });

  /* Mega menu position under header */
  function placeMega() {
    var h = $('.site-header'); if (!h) return;
    var b = h.getBoundingClientRect().bottom;
    $$('.mega').forEach(function (m) { m.style.top = b + 'px'; });
  }
  window.addEventListener('scroll', placeMega, { passive: true });
  window.addEventListener('resize', placeMega);
  placeMega();

  /* Cart */
  var cartDrawer = $('#CartDrawer');
  function renderShipBar(total) {
    var thr = S.freeShipping || 0;
    $$('[data-ship-bar]').forEach(function (bar) {
      if (!thr) { bar.hidden = true; return; }
      var pct = Math.min(100, Math.round(total / thr * 100));
      var msg = total >= thr ? esc(S.freeShippingReached) : 'You are <strong>' + formatMoney(thr - total) + '</strong> away from complimentary shipping';
      bar.innerHTML = '<p>' + msg + '</p><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div>';
    });
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    renderShipBar(cart.total_price);
    if (!cartDrawer) return;
    var list = $('[data-cart-items]', cartDrawer);
    var foot = $('[data-cart-foot]', cartDrawer);
    if (!cart.item_count) {
      list.innerHTML = '<div class="empty" style="padding:56px 0"><p class="h3">Your bag is empty</p><p>Discover a signature worth wearing.</p><a class="btn" href="' + (R.root || '/') + 'collections/all">Shop the collection</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    list.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + esc(it.product_title) + '" width="88" height="88" loading="lazy">' : '<div class="cart-item__ph">' + ($('#MonogramSvg') ? $('#MonogramSvg').innerHTML : '') + '</div>';
      var was = it.original_line_price > it.final_line_price ? '<span class="price__was">' + formatMoney(it.original_line_price) + '</span>' : '';
      return '<div class="cart-item"><a href="' + it.url + '">' + img + '</a><div><div class="cart-item__house">' + esc(it.vendor) + '</div><a class="cart-item__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        '<div style="display:flex;align-items:center"><div class="qty"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button><input type="number" value="' + it.quantity + '" min="0" aria-label="Quantity" data-line-input="' + (i + 1) + '"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<button type="button" class="cart-item__remove" data-line="' + (i + 1) + '" data-qty="0">Remove</button></div></div>' +
        '<div class="price" style="flex-direction:column;align-items:flex-end">' + was + '<span class="price__now">' + formatMoney(it.final_line_price) + '</span></div></div>';
    }).join('');
    $('[data-cart-subtotal]', cartDrawer).textContent = formatMoney(cart.total_price);
    var disc = $('[data-cart-discounts]', cartDrawer);
    if (disc) {
      var saved = cart.total_discount || 0;
      disc.hidden = !saved;
      if (saved) disc.innerHTML = '<span>Savings</span><span>&minus; ' + formatMoney(saved) + '</span>';
    }
  }
  function fetchCart() { return fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    return fetch((R.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); if (document.body.classList.contains('template-cart')) location.reload(); });
  }
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]'); if (!b) return;
      changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-qty'), 10));
    });
    cartDrawer.addEventListener('change', function (e) {
      var i = e.target.closest('[data-line-input]'); if (i) changeLine(parseInt(i.getAttribute('data-line-input'), 10), parseInt(i.value, 10) || 0);
      var n = e.target.closest('[data-cart-note]');
      if (n) fetch((R.cartUpdate || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
    });
  }
  if (window.initialCart) renderCart(window.initialCart);

  /* Add to bag. Handled on click (not form submit) so Shopify's analytics and the Meta pixel
     record exactly one AddToCart event per click. */
  function addToCart(form, btn) {
    if (form.dataset.adding) return;
    form.dataset.adding = '1';
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding&hellip;'; }
    fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(fetchCart)
      .then(function (c) { renderCart(c); openDrawer('CartDrawer'); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Sorry, that item could not be added.'); })
      .finally(function () { delete form.dataset.adding; if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]');
    if (!btn || S.cartType === 'page' || !cartDrawer) return;
    e.preventDefault();
    addToCart(btn.form || btn.closest('form'), btn);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || S.cartType === 'page' || !cartDrawer) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  /* Quantity steppers (product + cart page) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var input = b.parentNode.querySelector('input'); if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
    input.value = Math.max(parseInt(input.min || 1, 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Gallery */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]'); if (!t || !main) return;
      main.src = t.getAttribute('data-thumb'); main.srcset = '';
      $$('[data-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    });
    if (main) main.addEventListener('click', function () { window.open(main.currentSrc || main.src, '_blank'); });
  });

  /* Sticky add to cart */
  var sticky = $('[data-sticky-atc]'), mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
    }).observe(mainAtc);
  }

  /* Collection: sort & filters */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.type === 'checkbox' && !f.hasAttribute('data-no-auto')) f.submit(); });
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* Welcome popup */
  var modal = $('#WelcomeModal');
  function openModal(m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; store('welcomeDismissed', String(Date.now())); }
  if (modal) {
    var force = modal.hasAttribute('data-force-open');
    var dismissed = parseInt(store('welcomeDismissed') || '0', 10);
    var recently = dismissed && (Date.now() - dismissed) < 1000 * 60 * 60 * 24 * 14;
    if (force) openModal(modal);
    else if (!recently && !document.body.classList.contains('template-cart')) setTimeout(function () { if (!$('.drawer.is-open')) openModal(modal); }, (parseInt(modal.getAttribute('data-delay'), 10) || 8) * 1000);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-close-modal]')) closeModal(modal); });
  }
})();
